import {toAbsoluteUrl} from '../../../../../_ePulse/helpers'

const AddItemButton = (Props: any) => {
  const icon = toAbsoluteUrl(Props.icon)

  return (
    <button
      onClick={Props.onClick}
      style={{
        display: 'flex',
        borderStyle: 'Solid',
        borderRadius: '10px',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '8px',
      }}
    >
      <img src={icon} alt='user' style={{height: 30}} />
      <div style={{paddingLeft: '10px'}}>
        <h2>{Props.title}</h2>
        <div> {Props.subtitle}</div>
      </div>
      <div></div>
    </button>
  )
}

export {AddItemButton}
